import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthState, AuthStateModel} from '../states/auth/auth.state';
import {Store} from '@ngxs/store';
import {UserRolesEnum} from '../interfaces/UserRolesEnum';
import { PharmacyState, PharmacyStateModel } from '../states/pharmacy/pharmacy.state';
import { IUser } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})

export class AdminGuard  {

  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser: IUser = this.store.selectSnapshot(AuthState.currentUser);
    const activeUserIsLoggedInUser: boolean = this.store.selectSnapshot(AuthState.activeUserIsLoggedInUser);

    const pharmacyState: PharmacyStateModel = this.store.selectSnapshot(PharmacyState);
    const adminRoles = [UserRolesEnum.GlobalAdmin, UserRolesEnum.CompanyAdmin, UserRolesEnum.PharmacyAdmin];

    // if someone other than the current user unlocked the screen, don't allow admin access regardless of the unlocking user's role
    if (currentUser && activeUserIsLoggedInUser && adminRoles.includes(pharmacyState.currentPharmacy.role)) {
      return true;
    } else {
      this.router.navigateByUrl('/dashboard');
      return false;
    }

  }
}
